export default "__VITE_ASSET__54b9f36d__"